import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _hoisted_1 = { class: "loginContainer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1)
const _hoisted_3 = { class: "formContainer p-5 position-relative" }
const _hoisted_4 = {
  key: 0,
  class: "text-center mt-3"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_localized_text, {
        type: "h2",
        localizedKey: "Provider Login",
        text: "Provider Login",
        class: "text-center"
      }),
      (_ctx.supplierLabel)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.supplierLabel), 1))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        class: "mt-5",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
      }, [
        _createVNode(_component_form_field, {
          type: "email",
          modelValue: _ctx.credential.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.credential.username) = $event)),
          placeholderKey: "Email",
          placeholderValue: "Email",
          labelKey: "Email",
          labelValue: "Email"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_form_field, {
          class: "pb-3",
          type: "password",
          modelValue: _ctx.credential.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.credential.password) = $event)),
          placeholderKey: "Password",
          placeholderValue: "Password",
          labelKey: "Password",
          labelValue: "Password"
        }, null, 8, ["modelValue"]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary text-center justify-content-center w-100 mt-4",
          disabled: _ctx.disabled
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Login",
            text: "Login"
          })
        ], 8, _hoisted_5)
      ], 32),
      _hoisted_6,
      _createVNode(_component_router_link, {
        to: "/login",
        class: "btn btn-secondary text-center justify-content-center w-100"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_localized_text, {
            localizedKey: "Employee / Company Login",
            text: "Employee / Company Login"
          })
        ]),
        _: 1
      })
    ])
  ]))
}